"use client";

import Header from "@/components/common/header";
import { FaqArea, Footer, FormModal } from "@/components/common";
import ServiceArea from "@/components/pages/1bfs/service-area";
import { bfsfaq, bfsServices } from "@/data/data";
import ProjectArea from "@/components/home/project-area";
import MeetingForm from "@/components/pages/1bfs/meeting-form";
import PreFooter from "@/components/common/preFooter";
import useModal from "@/hooks/useModal";
import { useState } from "react";
import Hero from "./hero";
import WhatsappFloat from "./whatsapp-float";

const BfsPageContent = () => {
    const modal = useModal();
    const [modalTitle, setModalTitle] = useState("Ready to turn vision into action?");
    const handleModalOpen = (modalTitle?: string) => {
        if (modalTitle) {
            setModalTitle(modalTitle);
        }
        modal.openModal();
    };
    return (
        <>
            <Header />
            <Hero
                title="Product Engineering for the Creator Economy"
                description="We partner with platforms, agencies, and creator-focused businesses to design and build scalable products from monetization and communities to marketplaces, analytics, and AI-driven experiences."
            />
            <div className="section-padding-top-bottom">
                <div className="container custom-container">
                    <div className="row g-4 justify-content-between section-padding">
                        <div className="col-lg-4">
                            <h2 className="portfolio-details__title">
                                Why 1BFS
                            </h2>
                        </div>
                        <div className="col-lg-6">
                            <div className="portfolio-details__content">
                                <p>We’re at 1 Billion Followers Summit to meet teams building at the intersection of creators, agencies, and platforms. As operations scale, most teams hit friction, tools don’t talk to each other, workflows slow down, and revenue visibility disappears.</p>
                                <div className="bfs-highlight">
                                    <p>Our goal is to replace fragmented creator and agency operations with clean, scalable products.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <div className="container custom-container">
                <div className="row g-4 justify-content-between section-padding">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title">
                            When Ops Can’t Scale
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <div className="">
                                <div className="border-bottom-text">
                                    <p>
                                        Too many spreadsheets across campaigns, payouts, and reporting
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Disconnected tools for contracts, communication, and performance
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Slow manual workflows that delay execution and payments
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        No single view of revenue, performance, or ROI
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Tools that can’t adapt to your operational model
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ServiceArea
                title="What We Build"
                data={bfsServices}
            />
            <div className="section-padding-bottom">
                <ProjectArea />
            </div>
            <div className="">
                <MeetingForm />
            </div>
            <FaqArea style="style-1" title={"Frequently asked questions"} items={bfsfaq} />
            <PreFooter
                title="Ready to turn vision into action?"
                description={"Collaborate with our experts to define clear goals and build actionable strategies for success."}
                onModalOpen={handleModalOpen}
            />
            <WhatsappFloat />
            <Footer />

            {/* Form Modal */}
            <FormModal
                isOpen={modal.isOpen}
                onClose={modal.closeModal}
                onSubmit={() => {
                    modal.closeModal();
                }}
                title={modalTitle}
                submitButtonText="Request"
                dialogSlug={modalTitle}
            />
        </>
    );
};

export default BfsPageContent;
